import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [dayNightTheme, setDayNightTheme] = useState('is-light');
    const [seasonTheme, setSeasonTheme] = useState('is-summer');

    useEffect(() => {
        const savedDayNightTheme = localStorage.getItem('dayNightTheme') || 'is-light';
        const savedSeasonTheme = localStorage.getItem('seasonTheme') || 'is-summer';
        setDayNightTheme(savedDayNightTheme);
        setSeasonTheme(savedSeasonTheme);
        document.body.className = `${savedDayNightTheme} ${savedSeasonTheme}`;
    }, []);

    const changeDayNightTheme = () => {
        const newDayNightTheme = dayNightTheme === 'is-light' ? 'is-dark' : 'is-light';
        setDayNightTheme(newDayNightTheme);
        document.body.className = `${newDayNightTheme} ${seasonTheme}`;
        localStorage.setItem('dayNightTheme', newDayNightTheme);
    };

    const changeSeasonTheme = () => {
        const newSeasonTheme = seasonTheme === 'is-summer'
            ? 'is-autumn'
            : seasonTheme === 'is-autumn'
                ? 'is-winter'
                : 'is-summer';
        setSeasonTheme(newSeasonTheme);
        document.body.className = `${dayNightTheme} ${newSeasonTheme}`;
        localStorage.setItem('seasonTheme', newSeasonTheme);
    };

    return (
        <ThemeContext.Provider value={{ dayNightTheme, seasonTheme, changeDayNightTheme, changeSeasonTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
